import React from 'react';

const PrivacyPolicy = () => {
  const textStyle = {
    direction: 'rtl', // Right-to-left for Hebrew text
    textAlign: 'right', // Align text to the right
    fontFamily: 'Arial, sans-serif', // Clean and readable font
    lineHeight: '1.8', // Line height for better readability
    padding: '20px', // Padding for spacing
    backgroundColor: '#FAF7F0', // Background color
    color: '#4A4947', // Text color
    borderRadius: '10px', // Rounded corners
    margin: '20px', // Margin around the component
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
  };

  const headerStyle = {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '20px',
  };

  const subHeaderStyle = {
    fontSize: '18px',
    fontWeight: 'bold',
    margin: '15px 0',
  };

  const listStyle = {
    listStyleType: 'disc',
    paddingRight: '20px',
  };

  return (
    <div style={textStyle}>
      <h1 style={headerStyle}>ברוכים הבאים ל-mariage</h1>
      <p>
        המשימה שלנו היא להעניק לכולם גישה לניהול האירוע, להזמין ולקבל אישורי הגעה מהאורחים בכל
        דרך שבה תבחרו מבין האפשרויות, כדי לעשות זאת, אנו אוספים מידע אודות האירוע מכם ומצדדים
        שלישיים. אנו משתמשים במידע רק במקרים שבהם יש לנו בסיס חוקי ראוי לעשות כן.
      </p>
      <p>
        כתבנו מדיניות זו כדי לעזור לכם להבין איזה מידע נאסף, כיצד אנחנו משתמשים בו ואילו
        אפשרויות עומדות בפניכם בנושא זה.
      </p>

      <h2 style={subHeaderStyle}>אנו אוספים מידע במספר דרכים שונות</h2>
      
      <h3 style={subHeaderStyle}>
        1. כשאתם מוסרים לנו אותו או נותנים לנו רשות להשיג אותו
      </h3>
      <p>
        כאשר מצטרפים ל-mariage או משתמשים בה, אתם ממלאים פרטי מידע מסוימים, כולל שמכם, כתובת
        הדואר האלקטרוני, מספר הטלפון, התמונות וכל מידע שאתם מוסרים לנו.
      </p>
      <p>
        אם תחברו את חשבון Facebook, Google או חשבונות אחרים של צד שלישי ל-mariage, אנו נשתמש
        במידע מהחשבונות האלו כדי לאפשר לכם להירשם או להתחבר בקלות וכדי לשפר את החוויה שלכם
        ב-mariage. דבר זה תלוי בכללי המדיניות של חשבונות אלה לגבי פרטיות או בהגדרות שלהם.
      </p>

      <h3 style={subHeaderStyle}>2. אנו גם מקבלים מידע טכני כשאתם משתמשים ב-mariage</h3>
      <p>
        כשאתם משתמשים באתר, באפליקציה בנייד או בשירות אחר באינטרנט, נוצר ומתועד מידע מסוים
        לגבי הפעילות שלכם באינטרנט והרשת האלקטרונית שלכם באופן אוטומטי. דבר זה קורה גם כשאתם
        משתמשים ב-mariage. הנה כמה מסוגי המידע שאנו אוספים:
      </p>
      <ul style={listStyle}>
        <li>
          <strong>נתונים של קובצי עוגיות (Cookies):</strong> אנו משתמשים בקובצי עוגיות כדי
          לשמור על הגדרות התחברות לחשבון שלכם או הגדרות אחרות, כך שלא תצטרכו להגדיר אותן בכל
          פעם שאתם מבקרים ב-mariage.
        </li>
        <li>
          <strong>מידע על המכשיר:</strong> אנו אוספים מידע על המכשיר שממנו אתם ניגשים ל-mariage,
          כולל סוג המכשיר, מערכת ההפעלה, ההגדרות, מזהי מכשיר ייחודיים ונתוני קריסה.
        </li>
        <li>
          <strong>נתוני רצף הקלקות והסקת מסקנות:</strong> אנו משתמשים בפעילות שלכם, כמו מספר
          הצפיות בעמוד ההזמנה הדיגיטלית שלכם, כדי להסיק מסקנות לגבי ההעדפות שלכם.
        </li>
      </ul>

      <h3 style={subHeaderStyle}>3. השותפים והמפרסמים שלנו משתפים איתנו מידע</h3>
      <p>
        אנו גם מקבלים מידע עליכם ועל הפעילות שלכם מחוץ ל-mariage מצדדים שקשורים אלינו,
        מהמפרסמים שלנו ומהשותפים שלנו. לדוגמה:
      </p>
      <ul style={listStyle}>
        <li>
          מפרסמים או צדדים שלישיים משתפים איתנו מידע כדי לשפר את ביצועי המודעות ב-mariage
          ולהבין איזה סוג של מודעות כדאי להראות לכם בתוך ומחוץ ל-mariage.
        </li>
      </ul>
      <h1 style={headerStyle}>כיצד אנו משתמשים במידע שאנו אוספים</h1>
      <p>
        יש לנו מחויבות להציג לכם תוכן רלוונטי, מעניין ואישי עבורכם. כדי לעשות זאת, אנו
        משתמשים במידע שלכם כדי לספק לכם חוויה ולשפר אותה, כולל:
      </p>
      <ul style={listStyle}>
        <li>זיהוי שלכם כשאתם משתמשים ב-mariage.</li>
        <li>
          המלצות על הטבות או מבצעים שעשויים לדבר אליכם על בסיס הפעילות שלכם ב-mariage.
          לדוגמה, אם נראה שאתם מתחתנים, אנו עשויים להציע לכם הטבות שקשורות לירח דבש ועוד...
        </li>
        <li>תגובה לשאלות או להערות שאנו מקבלים מכם.</li>
      </ul>
      <p>
        יש לנו אינטרס לגיטימי לשימוש במידע שלכם בדרכים אלה. זהו חלק מהותי מהתפקוד של mariage
        והוא הכרחי כדי להבטיח ש-mariage והתכונות שלה יהיו רלוונטיים ויותאמו אליכם אישית.
      </p>
      <p>
        גם יש לנו אינטרס לגיטימי להבטיח ש-mariage תהיה בטוחה ולשפר את תכונות המוצר שלנו כך
        שתמשיכו לקבל את השירות הטוב ביותר. כולנו מרוויחים כשאנחנו משתמשים במידע שלכם כדי:
      </p>
      <ul style={listStyle}>
        <li>
          לבצע ניתוח נתונים ומחקרים על האירועים שמשתמשים ב-mariage ועל מעשיהם. לדוגמה, כשאנו
          מתעדים את התדירות שבה אנשים משתמשים בשתי גרסאות שונות של תכונה ב-mariage, אנו
          יכולים להבין איזו גרסה טובה יותר.
        </li>
        <li>לשפר את mariage ולהציע תכונות חדשות.</li>
        <li>
          לשלוח לכם עדכונים (למשל כאשר מתרחשת פעילות מסוימת ב-mariage, כמו למשל אישורי
          הגעה) וחדשות בדואר אלקטרוני או בהודעות דחיפה, על פי ההגדרות שלכם.
        </li>
      </ul>

      <h2 style={subHeaderStyle}>העברת המידע שלכם</h2>
      <p>
        mariage הוא שירות עולמי. כשאתם משתמשים במוצרים או בשירותים שלנו, אתם מרשים לנו
        להעביר ולאחסן את המידע שלכם מחוץ למדינה שבה אתם גרים, כולל ישראל, למטרות המתוארות
        במדיניות זו. יתכן שהגנות הפרטיות וזכויות הרשויות לגשת למידע האישי שלכם במדינות אלה
        שונות מאילו הקבועות במדינה שבה אתם גרים.
      </p>

      <h2 style={subHeaderStyle}>האפשרויות שלכם לגבי המידע שלכם</h2>
      <p>
        המטרה שלנו היא לספק לכם אפשרויות פשוטות ומשמעותיות לגבי המידע שלכם. אם יש לכם חשבון
        ב-mariage, חלק גדול מהאפשרויות האלה כלולות ישירות ב-mariage או בהגדרות שלכם. לדוגמה,
        תוכלו:
      </p>
      <ul style={listStyle}>
        <li>לערוך את המידע בפרופיל בכל עת.</li>
        <li>
          לסגור את חשבונכם בכל עת. כאשר תסגרו את החשבון, אנו נשבית אותו, נסיר מ-mariage את
          ההזמנה הדיגיטלית שלכם, את רשימת האורחים ונמחק את נתוני החשבון שלכם.
        </li>
      </ul>
      <p>
        שימו לב שעשויות להיות לנו סיבות משפטיות לשמור את הנתונים שלכם, למשל אם נקבל בקשה
        מרשויות אכיפת החוק המורה לנו לשמור על נתונים.
      </p>
      <p>
        בנוסף, זמינות לכם אפשרויות דרך המכשיר או התוכנה שבהם אתם משתמשים כדי לגשת ל-mariage.
        לדוגמה:
      </p>
      <ul style={listStyle}>
        <li>תוכלו לשלוט בעוגיות או בסוגים אחרים של אחסון נתונים מקומי דרך הדפדפן שבו אתם משתמשים.</li>
        <li>
          תוכלו לבחור כיצד ואם לשתף איתנו את התמונות, אנשי הקשר שלכם ונתונים אחרים דרך
          המכשיר הנייד שלכם.
        </li>
      </ul>
      <p>
        למידע נוסף על אפשרויות אלה, עיינו במידע שקיבלתם מספק המכשיר או התוכנה.
      </p>
      <h2 style={subHeaderStyle}>כיצד ומתי אנו משתפים מידע</h2>
      <ul style={listStyle}>
        <li>
          חברות צד שלישי, ספקי שירות או אנשים שאנו מעסיקים כדי לעבד מידע בשמנו על בסיס
          הוראותינו ולמטרות שמתוארות במדיניות פרטיות זו. לדוגמה, אנו משתפים מידע עם יועצי
          אבטחה כדי שיוכלו לסייע לנו להשתפר בזיהוי ספאם.
        </li>
        <li>
          רשויות אכיפת החוק או רשויות ממשלה, אם לדעתנו גילוי זה הכרחי באופן סביר לשם עמידה
          בחוק, תקנות או בקשה משפטית.
        </li>
        <li>
          במקרה שנהיה מעורבים במיזוג, ברכישה או בארגון מחדש הכוללים העברת המידע שתואר
          במדיניות זו, נשתף את המידע שלכם עם הצד המשתתף בתהליך.
        </li>
      </ul>

      <h2 style={subHeaderStyle}>כמה זמן אנחנו שומרים את המידע שלכם</h2>
      <p>
        אנו שומרים את המידע שלכם רק לתקופה שאנו זקוקים לו על מנת לספק לכם את השירות ולמלא את
        המטרות המתוארות במדיניות זו. כשאין לנו עוד צורך במידע שלכם, נסיר אותו מהמערכות שלנו
        או נבצע עליו דה-פרסונליזציה כך שלא ניתן יהיה להשתמש בו כדי לזהות אתכם.
      </p>

      <h2 style={subHeaderStyle}>האפשרויות שלכם</h2>
      <p>יש לכם אפשרויות ביחס למידע שיש לנו אודותיכם. לדוגמה, תוכלו:</p>
      <ul style={listStyle}>
        <li>לבקש גישה למידע שאנו אוספים ושומרים אודותיכם.</li>
        <li>לבקש מאיתנו לתקן או למחוק את המידע שלכם.</li>
        <li>
          להתנגד לעיבוד שלנו את המידע שלכם, כולל בקשה להפסיק לקבל מאיתנו דואר אלקטרוני עם
          חומרי שיווק.
        </li>
        <li>
          לבקש מאיתנו לשלוח לארגון אחר את המידע שמסרתם לנו, במקרים שבהם אנו מחזיקים במידע
          זה בהסכמתכם או לשם ביצוע חוזה מולכם.
        </li>
        <li>
          לבקש פרטים נוספים על המידע שאנו אוספים, כיצד ומדוע אנו משתמשים בו ומשתפים אותו.
        </li>
      </ul>
      <p>
        אם יש לכם שאלות או אם תרצו לממש את האפשרויות שעומדות לרשותכם, תוכלו ליצור קשר דרך
        עמוד "צור קשר".
      </p>

      <h2 style={subHeaderStyle}>כיצד אנו עורכים שינויים במדיניות זו</h2>
      <p>
        אנו עשויים לשנות את מדיניות זו מעת לעת. אם נעשה זאת, נפרסם את השינויים בעמוד זה.
        השינויים ייכנסו לתוקף עם פרסומם. אם השינויים יהיו משמעותיים, נספק הודעה בולטת או
        נבקש את הסכמתכם, כפי הנדרש בחוק.
      </p>

      <h2 style={subHeaderStyle}>צרו איתנו קשר</h2>
      <p>
        הדרך הטובה ביותר ליצור איתנו קשר או לממש את האפשרויות שלכם שתוארו למעלה היא דרך עמוד
        "צור קשר".
      </p>
      <p>עדכון בתאריך 20.01.2025</p>
    </div>
  );
};

export default  PrivacyPolicy;
